import React from 'react';
import DescriptionIcon from '@mui/icons-material/TextSnippetOutlined';
import { Container, RightContainer, Title, DropdownContainer } from './styled';
import  DropdownProjetos  from './DropdownProjetos';


const Projetos = () => {
  return (
  <Container >    
    <DescriptionIcon fontSize='small' />
      <RightContainer>
        <Title>Projetos</Title>
        <DropdownContainer>
					<DropdownProjetos />
				</DropdownContainer>
      </RightContainer>
  </Container>
  )
};

export default Projetos;
